import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import { quoteRequest } from '../redux/actions';
import CircularProgress from 'material-ui/CircularProgress';
import HelpIcon from 'material-ui/svg-icons/action/help-outline';
import NotesIcon from 'material-ui/svg-icons/action/speaker-notes';

const ServiceCard = ({onGetQuote, service, user, color, disabled, loading}) =>
<Card style={{marginBottom: "1rem", backgroundColor: disabled ? "lightgrey" : "#f3f2f0"}}>
    <CardHeader
        title={service.name}
        subtitle="Subtitle"
        actAsExpander={true}
        showExpandableButton={true}
        style={{backgroundColor: disabled ? "lightgrey" : color}}
    />
    <CardActions>
        <FlatButton label="Get Quote" disabled={disabled} 
            onClick={() => (onGetQuote(service, user))} icon={loading ? <CircularProgress /> : <HelpIcon />}/>
        <FlatButton label="Read Reviews" disabled={disabled} icon={<NotesIcon />}/>
    </CardActions>
    <CardText expandable={true}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi.
        Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque.
        Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.
    </CardText>
</Card>

const mapStateToProps = ({user, services}) => ({user, loading: services.loading});

const mapDispatchToProps = dispatch => ({
    onGetQuote: (service, user) => dispatch(quoteRequest(service, user))
});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceCard);


// WEBPACK FOOTER //
// ./src/components/ServiceCard.js